import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { AppConstants } from "../core/app.constants";
import { AuthAccessProvider } from "../core/core.auth";
import { BaseComponent, UserContext, UserInfo, RiepilogoScrivaniaStatus, PrenotazioneSala, Prenotazione } from "../core/core.component";
import { MessageProvider } from "../service/message.service";
import { UfficioService } from "app/service/ufficio.service";
import { SalaService } from "app/service/sala.service";
import { DetailScrivaniaComponent } from "app/scrivania-detail/scrivania-detail.component";
import { DetailSalaComponent } from "app/sala-detail/sala-detail.component";
import { UserService } from "../service/user.service";

declare var $: any;

@Component({
    selector: "app-scrivanie",
    templateUrl: "./scrivanie.component.html",
    styleUrls: ["./scrivanie.component.css"],
    host: { "(window:keydown)": "shortcutHandler($event)" },
})
export class ScrivanieComponent extends BaseComponent implements OnInit {

    static DIALOG_ID: string = "dettaglioGiornataUfficio";
    it: any = AppConstants.ITA_CALENDAR_CONF;
    userContext: UserContext;
    userInfo: UserInfo = new UserInfo();
    currentUser: string = null;
    filterDate: Date = new Date();

    completed: boolean = false;

    prenotazioniSalaList: PrenotazioneSala[];

    listStatoScrivanie: RiepilogoScrivaniaStatus[];
    listStatoScrivanieIsolate: RiepilogoScrivaniaStatus[];
    listStatoScrivanieGruppo1: RiepilogoScrivaniaStatus[];
    listStatoScrivanieGruppo2: RiepilogoScrivaniaStatus[];
    listStatoScrivanieSalaRiunioni: RiepilogoScrivaniaStatus[];

    showDetailDay: boolean = false;
    showDetailSalaDay: boolean = false;

    showDeleteAlertPrenotazioneSala: boolean = false;
    currentPrenotazioneSala: PrenotazioneSala = null;

    constructor(
        protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private userService: UserService,
        private ufficioService: UfficioService,
        private salaService: SalaService
    ) {
        super(authAccess, router, messageProvider);
        this.messageProvider.clearAll();
        this.userContext = this.authAccess.getUserContext();
        this.currentUser = this.userContext.userId;
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();

        if (this.userContext == null) {
            this.authAccess.invalidate();
        } else {
            this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
                (result) => {
                    this.userInfo = result;
                    if (this.userInfo.managedUsers.length > 0 && this.userInfo.managedUsers.indexOf(this.userContext.userId) < 0) {
                        this.userInfo.managedUsers.push(this.userContext.userId);
                    }
                },
                (error) => {
                    this.handleError(error);
                }
            );
            this.ufficioService.getRefreshEvent().subscribe(() => this.reload());
            this.reload();
        }
    }

    reload() {
        this.updateScrivanieStatus();
    }

    switchDay() {
        this.updateScrivanieStatus();
    }

    updateScrivanieStatus() {
        this.ufficioService.riepilogoScrivanieGiorno(this.userContext.srmToken, this.filterDate).subscribe((data) => {
            if (data.listRiepilogo != null) {
                for (let i = 0; i < data.listRiepilogo.length; i++) {

                    let curr = data.listRiepilogo[i];
                    if (curr.scrivania.idUserDefault != null) {
                        data.listRiepilogo[i].scrivania.color = AppConstants.intToRGB(
                            AppConstants.hashCode(curr.scrivania.userName + "." + curr.scrivania.idUserDefault)
                        );
                    }
                    if (curr.listPrenotazioni != null) {
                        for (let j = 0; j < curr.listPrenotazioni.length; j++) {
                            let curr2 = curr.listPrenotazioni[j];
                            data.listRiepilogo[i].listPrenotazioni[j].color = AppConstants.intToRGB(AppConstants.hashCode(curr2.nomeUser + "." + curr2.idUser));
                        }
                    }
                }
            }

            this.listStatoScrivanie = data.listRiepilogo;
            if (this.listStatoScrivanie.length >= 10) {
                this.listStatoScrivanieIsolate = this.listStatoScrivanie.slice(0, 2);
                this.listStatoScrivanieGruppo1 = this.listStatoScrivanie.slice(2, 6);
                this.listStatoScrivanieGruppo2 = this.listStatoScrivanie.slice(6, 10);

                this.completed = true;
            }
        });
        this.salaService.riepilogoPrenotazioneSalaGiorno(this.userContext.srmToken, this.filterDate).subscribe((data) => {
            if (data.listRiepilogo != null) {
                for (let i = 0; i < data.listRiepilogo.length; i++) {
                    let curr = data.listRiepilogo[i];
                    if (curr.idUser != null) {
                        //data.listRiepilogo[i].color = AppConstants.intToRGB(AppConstants.hashCode(curr.nomeUser + "." + curr.idUser));
                    }
                }
                this.prenotazioniSalaList = data.listRiepilogo;
            }
        });
    }

    // https://stackoverflow.com/questions/563406/how-to-add-days-to-date
    previousDay() {
        let newD = new Date(this.filterDate);
        newD.setDate(newD.getDate() - 1);
        this.filterDate = newD;
        this.switchDay();
    }
    nextDay() {
        let newD = new Date(this.filterDate);
        newD.setDate(newD.getDate() + 1);
        this.filterDate = newD;
        this.switchDay();
    }

    isOccupataGiornata(statoScrivania: RiepilogoScrivaniaStatus) {
        if (!statoScrivania.disponibile) {
            if (statoScrivania.listPrenotazioni) {
                if (!statoScrivania.disponibile && statoScrivania.listPrenotazioni.length == 1) {
                    if (statoScrivania.listPrenotazioni[0].tipo == "F") {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
        return false;
    }

    isOccupataSoloMattina(statoScrivania: RiepilogoScrivaniaStatus) {
        if (!statoScrivania.disponibile) {
            if (statoScrivania.listPrenotazioni) {
                if (!statoScrivania.disponibile && statoScrivania.listPrenotazioni.length == 1) {
                    if (statoScrivania.listPrenotazioni[0].tipo == "M") {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
        return false;
    }

    isOccupataSoloPomeriggio(statoScrivania: RiepilogoScrivaniaStatus) {
        if (!statoScrivania.disponibile) {
            if (statoScrivania.listPrenotazioni) {
                if (!statoScrivania.disponibile && statoScrivania.listPrenotazioni.length == 1) {
                    if (statoScrivania.listPrenotazioni[0].tipo == "P") {
                        return true;
                    } else {
                        return false;
                    }
                }
            }
        }
        return false;
    }

    isOccupataMattinaPomeriggio(statoScrivania: RiepilogoScrivaniaStatus) {
        if (!statoScrivania.disponibile) {
            if (statoScrivania.listPrenotazioni) {
                if (!statoScrivania.disponibile && statoScrivania.listPrenotazioni.length == 2) {
                    return true;
                }
            }
        }
        return false;
    }

    isFullOccupata(statoScrivania: RiepilogoScrivaniaStatus) {
        if (!statoScrivania.disponibile) {
            if (statoScrivania.listPrenotazioni) {
                if (!statoScrivania.disponibile && statoScrivania.listPrenotazioni.length == 1) {
                    if (statoScrivania.listPrenotazioni[0].tipo == "F") {
                        return true;
                    } else {
                        return false;
                    }
                } else if (!statoScrivania.disponibile && statoScrivania.listPrenotazioni.length == 2) {
                    return true;
                }
            } else {
                return true;
            }
        }
        return false;
    }

    isAbilRimuoviDetail(statoScrivania: RiepilogoScrivaniaStatus, prenotazione: Prenotazione) {
        let abil = this.userInfo.admin;
        if (!abil && prenotazione != null)
            abil = prenotazione.nomeUser.toLowerCase() == this.currentUser || this.userInfo.managedUsers.includes(prenotazione.nomeUser.toLowerCase());
        else if (!abil && statoScrivania != null)
            abil = statoScrivania.scrivania.userName != null && (statoScrivania.scrivania.userName.toLowerCase() == this.currentUser || this.userInfo.managedUsers.includes(statoScrivania.scrivania.userName.toLowerCase()));
        return abil;
    }

    openRimuoviDetail(statoScrivania: RiepilogoScrivaniaStatus, prenotazione: Prenotazione) {
        this.closeDetailDay();
        this.ufficioService.openScrivaniaDetail(this.filterDate, statoScrivania, prenotazione);
    }

    openDetail(statoScrivania: RiepilogoScrivaniaStatus) {
        this.closeDetailDay();
        this.ufficioService.openScrivaniaDetail(this.filterDate, statoScrivania, null);
    }

    openPrenotazioneSala() {
        this.salaService.openPrenotazioneSala(this.filterDate);
    }

    openLiberazioneSala(statoPrenotazioneSala: PrenotazioneSala) {
        this.salaService.openLiberazioneSala(this.filterDate, statoPrenotazioneSala);
    }

    openModificaPrenotazioneSala(statoPrenotazioneSala: PrenotazioneSala) {
        this.salaService.openModificaPrenotazioneSala(this.filterDate, statoPrenotazioneSala);
    }

    closeDetailDay() {
        this.showDetailDay = false;
        $("#" + ScrivanieComponent.DIALOG_ID).modal("hide");
    }

    shortcutHandler(event) {
        if (event.keyCode == 27) {
            // ESC
            this.close();
        }
    }

    close() {
        this.reload();
        $("#" + DetailScrivaniaComponent.DIALOG_ID_PRENOTA).modal("hide");
        $("#" + DetailScrivaniaComponent.DIALOG_ID_LIBERA).modal("hide");
        $("#" + DetailSalaComponent.DIALOG_ID_PRENOTA).modal("hide");
        $("#" + DetailSalaComponent.DIALOG_ID_LIBERA).modal("hide");
    }
}



// WEBPACK FOOTER //
// ./src/app/scrivanie/scrivanie.component.ts